import type { SubscriptionSnapshot } from "./types";

export type SubscriptionStatus = "idle" | "loading" | "ready" | "error";

export interface SubscriptionState {
  status: SubscriptionStatus;
  snapshot: SubscriptionSnapshot | null;
  errorMessage: string | null;
}

const listeners = new Set<() => void>();

let state: SubscriptionState = {
  status: "idle",
  snapshot: null,
  errorMessage: null,
};

function emit(): void {
  listeners.forEach((listener) => listener());
}

export function getSubscriptionState(): SubscriptionState {
  return state;
}

export function subscribeSubscriptionState(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function setSubscriptionState(nextState: SubscriptionState): void {
  state = nextState;
  emit();
}

export function resetSubscriptionState(): void {
  setSubscriptionState({
    status: "idle",
    snapshot: null,
    errorMessage: null,
  });
}
